export const TAKEOFF_COST_BASIS = {
  count: "count",
  measurement: "measurement",
} as const;

export type TakeoffCostBasis =
  (typeof TAKEOFF_COST_BASIS)[keyof typeof TAKEOFF_COST_BASIS];
